import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { takeFirst } from "~/features/app/utils";
import { Link } from "~/features/ui/link";
import { isLinkValid } from "~/features/ui/link/utils";
import { useLinkActive } from "~/features/ui/link/use-link-active";
import { Icon } from "~/features/ui/icon";
import ArrowTopRight from "~/public/icons/arrow-top-right.svg";
const fragment = graphql(`
  fragment LandingFooterLink on footerLinks_link_BlockType {
    link: baseLink {
      ...Link
    }
    label: baseText
  }
`);
export function FooterLink(props: FragmentType<typeof fragment>) {
  const {
    label,
    link: _link
  } = useFragment(fragment, props);
  const link = takeFirst(_link);
  const isActive = useLinkActive(link || undefined);
  if (!isLinkValid(link)) {
    return null;
  }
  const isExternal = Boolean((link as {
    newWindow?: boolean;
  }).newWindow);
  return <_StyledLink {...link}>
      {"text" in link && <_StyledSpan>
          <_StyledSpan2 $_css={[{
        "position": "relative",
        "display": "inline"
      }, isActive && {
        "&::after": {
          "content": "var(--tw-content)",
          "position": "absolute",
          "left": "0",
          "right": "0",
          "bottom": "0",
          "height": "0.2rem",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
          "--tw-content": "\"\""
        }
      }]}>
            {link.text as string}
          </_StyledSpan2>
          {isExternal && <Icon icon={ArrowTopRight} size="16" />}
        </_StyledSpan>}
      {label && <_StyledSpan3>
          {label}
        </_StyledSpan3>}
    </_StyledLink>;
}
var _StyledLink = _styled(Link).withConfig({
  componentId: "sc-sf-18st1c7-0"
})({
  "display": "inline-flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "rowGap": "0.8rem",
  "transitionProperty": "opacity",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out",
  "@media (hover: hover)": {
    "&:hover": {
      "opacity": "0.6"
    }
  }
});
var _StyledSpan = _styled2("span").withConfig({
  componentId: "sc-sf-18st1c7-1"
})({
  "display": "inline-flex",
  "alignItems": "center",
  "columnGap": "0.4rem"
});
var _StyledSpan2 = _styled3("span").withConfig({
  componentId: "sc-sf-18st1c7-2"
})`${p => p.$_css}`;
var _StyledSpan3 = /*#__PURE__*/_styled4("span").withConfig({
  displayName: "footer-link___StyledSpan3",
  componentId: "sc-idsjjx-0"
})({
  "display": "inline-block",
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.2rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.024rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(92 92 92 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.028000000000000004rem",
    "fontWeight": "400"
  }
});